import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 8px 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0 0;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  font-weight: 600;
`;

export const DescriptionWrapper = styled.div`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.black7};
`;

export const LinkWrapper = styled.a`
  color: ${({ theme }) => theme.colors.green7};
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    color: ${({ theme }) => theme.colors.green8} !important;
  }
`;

export const FileWrapper = styled.div`
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 12px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  border-radius: 8px;
`;

export const FileInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.green7};
  color: ${({ theme }) => theme.colors.white};
`;
